export default function MySQL_DAYOFYEAR() {
  return (
    <div>
      <h2>MySQL_DAYOFYEAR</h2>    </div>
  );
}